import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuggestionService {

  private readonly http = inject(HttpClient);

  addNewSuggestion(params:any){
    return this.http.post(`${environment.api.host_path}/suggestion`, params);
  }

  editSuggestion(params: any) {
    return this.http.put(`${environment.api.host_path}/suggestion`, params);
  }

  getSuggestionsList(pageIndex: number, pageSize: number, sortBy: string, suggestionFilter?: { search?: string }): Observable<any> {
    let params = new HttpParams().set('pageIndex', pageIndex).set('pageSize', pageSize).set('sortBy', sortBy);
    if(suggestionFilter) {
      if(suggestionFilter.search) {
        params = params.set('search', suggestionFilter.search);
      }
    }
    return this.http.get<any>(`${environment.api.host_path}/suggestion/list`, { params });
  }

  deleteSuggestion(id: number){
    return this.http.delete(`${environment.api.host_path}/suggestion/${id}`);
  }
}
